(() => {
  if (window.a1SearchReady) return;
  window.a1SearchReady = true;
  const states = new WeakMap();
  const selector = 'form[role="search"],form.search-form,form.a1-overlay-search,form.a1-mobile-search';
  const getForm = el => el && el.closest && el.closest(selector);
  function close(state) {
    if (!state) return;
    state.panel.hidden = true;
    state.input.setAttribute('aria-expanded', 'false');
    state.input.removeAttribute('aria-activedescendant');
    state.index = -1;
  }
  function submit(form) {
    const input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) { if (input) input.focus(); return; }
    const url = new URL(form.action || '/search', location.origin);
    url.searchParams.set('q', input.value.trim());
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    close(states.get(input));
    input.blur();
    location.assign(url.href);
  }
  function initialize() {
    document.querySelectorAll(selector).forEach(form => {
      const input = form.querySelector('input[name="q"]');
      if (!input || input.dataset.a1SearchFixed) return;
      input.dataset.a1SearchFixed = 'true';
      input.setAttribute('enterkeyhint', 'search');
      input.setAttribute('inputmode', 'search');
      input.setAttribute('autocapitalize', 'none');
      input.setAttribute('autocomplete', 'off');
      if (input.type === 'text') input.type = 'search';
      form.dataset.a1SearchForm = 'true';
      form.querySelectorAll('button[type="submit"],input[type="submit"]').forEach(button => {
        button.dataset.a1SearchSubmit = 'true';
        button.disabled = false;
      });
      if (!form.matches('.a1-overlay-search,.a1-mobile-search')) return;
      const panel = document.createElement('div');
      panel.className = 'a1-product-suggestions';
      panel.id = 'a1-suggestions-' + Math.random().toString(36).slice(2);
      panel.hidden = true;
      panel.setAttribute('role', 'listbox');
      panel.setAttribute('aria-label', 'Produktvorschläge');
      form.appendChild(panel);
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-controls', panel.id);
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      const state = { input, panel, index: -1, links: [], timer: null, controller: null };
      states.set(input, state);
      input.addEventListener('input', () => {
        clearTimeout(state.timer);
        if (state.controller) state.controller.abort();
        state.links = [];
        close(state);
        const term = input.value.trim();
        if (term.length < 2) return;
        state.timer = setTimeout(async () => {
          state.controller = new AbortController();
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const url = new URL(root + 'search/suggest.json', location.origin);
          url.searchParams.set('q', term);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '5');
          try {
            const response = await fetch(url, { signal: state.controller.signal });
            if (!response.ok) throw new Error('Search suggestions unavailable');
            const data = await response.json();
            if (input.value.trim() !== term || document.activeElement !== input) return;
            panel.replaceChildren();
            state.links = [];
            (data.resources && data.resources.results && data.resources.results.products || []).forEach(product => {
              const target = new URL(product.url, location.origin);
              if (target.origin !== location.origin) return;
              const link = document.createElement('a');
              link.href = target.href;
              link.textContent = product.title;
              link.id = panel.id + '-' + state.links.length;
              link.setAttribute('role', 'option');
              link.setAttribute('aria-selected', 'false');
              panel.appendChild(link);
              state.links.push(link);
            });
            const all = document.createElement('button');
            all.type = 'button';
            all.className = 'a1-all-search-results';
            all.textContent = 'Alle Suchergebnisse anzeigen';
            all.addEventListener('click', () => submit(form));
            panel.appendChild(all);
            panel.hidden = false;
            input.setAttribute('aria-expanded', 'true');
          } catch (error) {
            if (error.name !== 'AbortError') close(state);
          }
        }, 300);
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape') { close(state); return; }
        if (!['ArrowDown', 'ArrowUp'].includes(event.key) || panel.hidden || !state.links.length) return;
        event.preventDefault();
        state.index = (state.index + (event.key === 'ArrowDown' ? 1 : -1) + state.links.length) % state.links.length;
        state.links.forEach((link, index) => link.setAttribute('aria-selected', String(index === state.index)));
        input.setAttribute('aria-activedescendant', state.links[state.index].id);
        state.links[state.index].scrollIntoView({ block: 'nearest' });
      });
      form.addEventListener('focusout', () => setTimeout(() => {
        if (!form.contains(document.activeElement)) close(state);
      }, 0));
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches || !form.matches(selector) || !form.querySelector('input[name="q"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submit(form);
  }, true);
  document.addEventListener('pointerdown', event => {
    const button = event.target.closest && event.target.closest('[data-a1-search-submit]');
    if (!button || event.button > 0 || !matchMedia('(max-width: 768px)').matches) return;
    const form = getForm(button);
    if (!form || !form.querySelector('input[name="q"]').value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    submit(form);
  }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || event.isComposing || !event.target.matches('input[name="q"]')) return;
    const form = getForm(event.target);
    if (!form) return;
    const state = states.get(event.target);
    if (state && !state.panel.hidden && state.index >= 0 && state.links[state.index]) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(state.links[state.index].href);
    } else if (state || !event.target.getAttribute('aria-activedescendant')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      submit(form);
    }
  }, true);
  document.addEventListener('pointerdown', event => {
    document.querySelectorAll('[data-a1-search-fixed]').forEach(input => {
      const state = states.get(input);
      if (state && !input.form.contains(event.target)) close(state);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
// A1 mobile search icon focus fix 2026-11-03
(() => {
  function focusSearch(trigger) {
    const target = trigger.closest('.header-wrapper,.site-header,.header,.mobile-nav,header') || document;
    const panel = document.querySelector('.a1-mobile-search,.a1-overlay-search,.search-modal,.search-bar__interior,.header__search');
    const input = (panel && panel.querySelector('input[name="q"],input[type="search"]')) || target.querySelector('input[name="q"],input[type="search"]') || document.querySelector('form[role="search"] input[name="q"]');
    if (!input) return;
    const details = input.closest('details');
    if (details) details.open = true;
    if (panel && panel.hidden) panel.hidden = false;
    requestAnimationFrame(() => input.focus({preventScroll:true}));
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('button[aria-label*="Suche"],a[aria-label*="Suche"],.header__icon--search,[data-search-toggle],.mobile-search-toggle');
    if (!trigger) return;
    setTimeout(() => focusSearch(trigger), 0);
  });
})();
